import { request } from '@/utils/request';
import type { ApiResponse, WrappedItemsResult } from './types';

const currenciesApi = {
  getAll(params?: cyrian.api.currencies.GetParams): ApiResponse<WrappedItemsResult<cyrian.api.currencies.Currency[]>> {
    return request({
      method: 'get',
      url: '/currencies',
      params,
    });
  },
};

export default currenciesApi;
